var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHappyFaceGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono_bueno",
    transform: "translate(-8951.268 -2067.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_117",
    "data-name": "Uni\\xF3n 117",
    d: "M6.937,15l-.179-.023c-.129-.017-.262-.033-.394-.053a7.418,7.418,0,0,1-3.839-1.8A7.524,7.524,0,0,1,.263,9.514,9.4,9.4,0,0,1,0,8.058V8.031L0,6.937l.024-.18c.016-.128.033-.26.052-.392A7.539,7.539,0,0,1,5.5.26,9.651,9.651,0,0,1,6.941,0l.028,0L8.063,0l.18.023c.128.017.26.033.392.053a7.427,7.427,0,0,1,3.841,1.8,7.5,7.5,0,0,1,2.26,3.6A9.579,9.579,0,0,1,15,6.941l0,.028,0,1.1-.031.233c-.022.169-.044.344-.075.517A7.537,7.537,0,0,1,9.38,14.772,10.5,10.5,0,0,1,8.06,15l-.014,0ZM3.2,3.192A6.079,6.079,0,0,0,7.5,13.583H7.5A6.088,6.088,0,0,0,11.811,3.2,6.084,6.084,0,0,0,3.2,3.192Z",
    transform: "translate(8951.268 2067.267)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_118",
    "data-name": "Uni\\xF3n 118",
    d: "M4.023,3.342a4.727,4.727,0,0,1-2.8-.94A3.851,3.851,0,0,1,.1,1.113.8.8,0,0,1,.075.391.684.684,0,0,1,.614.007.659.659,0,0,1,1.279.35,3,3,0,0,0,3.555,1.817a4.753,4.753,0,0,0,.72.058,3.793,3.793,0,0,0,1.6-.346A2.757,2.757,0,0,0,7.161.375.7.7,0,0,1,7.764,0a.659.659,0,0,1,.354.105.757.757,0,0,1,.234,1.018A4.089,4.089,0,0,1,6.8,2.688a5.225,5.225,0,0,1-2.773.653Zm0-.249Z",
    transform: "translate(8954.54 2075.342)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_119",
    "data-name": "Uni\\xF3n 119",
    d: "M1.2,2.4A1.225,1.225,0,0,1,0,1.192,1.2,1.2,0,0,1,1.206,0a1.2,1.2,0,0,1,0,2.4Z",
    transform: "translate(8955.309 2071.768)",
    fill: "#85af26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_120",
    "data-name": "Uni\\xF3n 120",
    d: "M1.194,2.4A1.21,1.21,0,0,1,0,1.2,1.187,1.187,0,0,1,1.2,0a1.208,1.208,0,0,1,.868.36,1.177,1.177,0,0,1,.343.848,1.225,1.225,0,0,1-1.2,1.2Z",
    transform: "translate(8959.819 2071.768)",
    fill: "#85af26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappyFaceGreen);
export default __webpack_public_path__ + "static/media/icon_happy_face_green.94954ed42b4757551ec712609019470e.svg";
export { ForwardRef as ReactComponent };